<template>
  <b-card>
    <div
      v-if="loadError"
      role="alert"
      class="py-3 text-center"
    >
      {{ loadError }}
    </div>
    <FormView
      v-else
      :data="$store.getters['userV2/detailData']"
      :fields="$store.getters['userV2/tableFields']"
      @load="loadData"
    />
  </b-card>
</template>

<script>
import FormView from '@/layouts/components/v2/FormView.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    FormView,
  },
  data() {
    return { loadError: '' }
  },
  methods: {
    async loadData(id) {
      this.loadError = ''
      try {
        await this.$store.dispatch('userV2/getDetail', id)
      } catch (error) {
        this.loadError = error.response && error.response.status === 404
          ? 'Akun tidak ditemukan atau sudah dihapus.'
          : 'Gagal memuat akun. Silakan coba lagi.'
      }
    },
  },
}
</script>

<style scoped>

</style>
